import { useEffect, useState } from 'react';
import { useLocation, useHistory, withRouter } from 'react-router-dom';
import { Toaster } from 'components/generic';
import { useQuery } from 'react-query';
import * as api from 'actions';
import { Images } from 'assets/Images'
import { map, isEmpty } from 'lodash';
import SimpleCrypto from "simple-crypto-js";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import './style.scss';
import Cookies from 'js-cookie';

function LandingPage() {
    const { REACT_APP_LOGIN_URL, REACT_APP_REDIRECT_URL, REACT_APP_GEOLOCATION, REACT_APP_ENABLE_MULTIENTITY, REACT_APP_EID } = process.env;
    const location = useLocation();
    const history = useHistory();
    let loginObj = { username: '', password: '', code: '', redirect_uri: '', authorizationcode: 'true' };
    const [showToaster, setShowToaster] = useState(false);
    const [loginButton, setLoginButton] = useState(false);
    const [resObj, setResObj] = useState(null);
    const deviceId = "deviceID"

    useEffect(() => {
        showToaster && setTimeout(() => setShowToaster(false), 3000)
    }, [showToaster]);


    const getDeviceId = async () => {
        let deviceid = Cookies.get(deviceId);
        if (!deviceid) {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            deviceid = result.visitorId;
            if (typeof window !== 'undefined') {
                Cookies.set(deviceId, deviceid, { expires: 365, path: '' });
            }
        }
        return deviceid;
    };
    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    localStorage.setItem('co_lat', position.coords.latitude);
                    localStorage.setItem('co_lon', position.coords.longitude);
                    if (REACT_APP_GEOLOCATION && localStorage.getItem('co_lat') && localStorage.getItem('co_lon')) {
                        let deviceid = await getDeviceId();
                        const resObj = {
                            lat: localStorage.getItem('co_lat'),
                            lng: localStorage.getItem('co_lon'),
                            application: "APPROVAL_PORTAL",
                            device: deviceid
                        };
                        setResObj(resObj);

                        refetchLoginTime();
                    }
                },
                (error) => {
                    alert('Geolocation is not supported or permission denied. Please use an updated browser.');
                }
            );
        } else {
            alert('Geolocation is not supported by this browser. Please use an updated web browser to login');
            history.push('/');
        }
        const url = window.location.href;
        const parts = url.split('?')[0].split('/').filter(ele => ele);
        const eId = parts[parts.length - 1];
        if ((REACT_APP_ENABLE_MULTIENTITY == "true" ? eId : REACT_APP_EID) && localStorage.getItem('e_id') === null) {
            localStorage.setItem('e_id', REACT_APP_ENABLE_MULTIENTITY == "true" ? eId : REACT_APP_EID);
            console.log('E-ID saved:', REACT_APP_ENABLE_MULTIENTITY, eId, REACT_APP_EID);
        }
        console.log(window.location.href);
    }, []);

    const { refetch: refetchLogin } = useQuery(['login', loginObj], () => api.login(loginObj), {
        enabled: false,
        onSuccess: async (data) => {
            localStorage.setItem('_ac', data?.access_token);
            localStorage.setItem('_rc', data?.refresh_token);
            localStorage.setItem('_sc', data?.session_state);
            if (REACT_APP_GEOLOCATION && localStorage.getItem('co_lat') && localStorage.getItem('co_lon')) {
                const deviceid = await getDeviceId();
                setResObj({
                    lat: localStorage.getItem('co_lat'),
                    lng: localStorage.getItem('co_lon'),
                    application: "APPROVAL_PORTAL",
                    device: deviceid
                });
                refetchLoginTime();
            }
            refetchAuth();
        }
    });

    const { refetch: refetchLoginTime } = useQuery(
        ['loginTime', resObj],
        () => api.getLoginTime(resObj),
        {
            enabled: false,
            onSuccess: () => {
            }
        }
    );

    const { refetch: refetchLogout } = useQuery(['logout', ''], () => api.logout(), {
        enabled: false,
        onSuccess: () => {
            if (REACT_APP_GEOLOCATION && localStorage.getItem('co_lat') && localStorage.getItem('co_lon')) {
                refetchLogoutTime();
            } else {
                history.push({ pathname: '/missing-privilege' });
                localStorage.clear();
            }
        }
    });

    const { refetch: refetchLogoutTime } = useQuery(['logout'], () => api.logoutTime(), {
        enabled: false,
        onSuccess: () => {
            history.push({ pathname: '/missing-privilege' });
            localStorage.clear();
        }
    });

    // authenticate api
    const { refetch: refetchAuth } = useQuery(['getAuthenticate', ''], () => api.authenticate(), {
        enabled: false, onSuccess: (data) => {
            if (data?.data?.data?.attributes?.applications.includes('APPROVAL_PORTAL')) {
                const { name, permissions } = data?.data?.data?.roles[0];
                localStorage.setItem('username', data?.data?.data?.username || '');
                localStorage.setItem('_sro', api.encrypting(name));
                // const arr = map(data?.data?.data?.roles, el => el.permissions);
                // const roles = arr,
                //     keys = ['exception_maintenance', 'matrix_maintenance', 'workflow_maintenance'],
                //     addToSet = (s, v) => s.add(v),
                //     result = Object.fromEntries(keys.map(k => [
                //         k,
                //         [...roles.reduce((r, o) => (o[k] || []).reduce(addToSet, r), new Set)]
                //     ]));
                // const filtered = Object.keys(result)
                //     .filter(key => Array.isArray(result[key]) && result[key].length != 0)
                //     .reduce((acc, key) => { acc[key] = result[key]; return acc }, {});

                const prKeys = Object.keys(permissions).map(el => ({ RoleName: el, applicationId: 'APPROVAL_PORTAL', permissions: '' }));
                const result = prKeys.map(el => Object.assign({ ...el, permissions: permissions[el.RoleName] }));
                localStorage.setItem('_ro', api.encrypting(JSON.stringify(data?.data?.data?.roles)));
                localStorage.setItem('access-list', api.encrypting(JSON.stringify(result)));

                // if (!isEmpty(filtered)) {
                //     localStorage.setItem('_ro', api.encrypting(JSON.stringify(result)));
                //     result?.hasOwnProperty('workflow_maintenance') ? history.push({ pathname: '/workflow-maintenance' }) : history.push({ pathname: '/exception-maintenance' });
                // } else {
                //     refetchLogout();
                // }
                if (result?.length > 0 && result[0]?.RoleName) {
                    getNavUrl(result[0]?.RoleName);
                } else {
                    refetchLogout();
                }
            } else {
                refetchLogout();
            }

        }
    });

    const getNavUrl = (name) => {
        switch (name) {
            case 'workflow_maintenance':
                history.push({ pathname: '/workflow-maintenance' });
                break;
            case 'exception_maintenance':
                history.push({ pathname: '/exception-maintenance' });
                break;
            case 'matrix_maintenance':
                history.push({ pathname: '/matrix-maintenance' });
                break;
            default:
                refetchLogout();
                break;
        }
    }

    const handleUrl = () => {
        window.location.href = REACT_APP_LOGIN_URL.replaceAll('E_ID', localStorage.getItem('e_id'));
        setLoginButton(false);
    }

    useEffect(() => {
        if (location.search.includes('?state')) {
            const params = new URLSearchParams(location.search);
            loginObj.code = params.get('code');
            loginObj.redirect_uri = REACT_APP_REDIRECT_URL?.replaceAll('E_ID', localStorage.getItem('e_id'));
            setLoginButton(false);
            if (REACT_APP_GEOLOCATION) {
                if (localStorage.getItem('co_lon') && localStorage.getItem('co_lat')) {
                    refetchLogin();
                } else {
                    alert("please turn on the geo-location");
                    history.push('/');
                }
            } else {
                refetchLogin();
            }
        } else if (location.search.includes('?appFrom')) {
            handleUrl();
        } else {
            setLoginButton(true);
        }
    }, [location]);

    // handle toaster
    const handleToaster = (e) => {
        e === 'close' && setShowToaster(false);
    }

    return (
        <>
            <div className="landing-wrap">
                <div className="landing-wrap__container">
                    <div className="row landing-wrap__row">
                        <div className="col-4">
                            <h1>Enterprise <span>Digital Automation</span> Platform</h1>
                            <p>We built solutions based on these platform capabilities that cater to specific use cases. </p>
                            {loginButton && <button onClick={handleUrl}>Click here to login</button>}
                        </div>
                        <div className="col-8">
                            <img src={Images.banner} alt='Banner' />
                        </div>
                    </div>
                </div>
            </div>
            {/* [YOMA] - [ID-50650] - (Collections to Approval Redirect Issue) - (21-11-2022) */}
            {showToaster && <Toaster center top error={true} header='Oops!!! You dont have access' content='Please contact admin' handleUndoClose={handleToaster} />}
        </>
    )
}

export default withRouter(LandingPage);
